import React from 'react';
import { useTranslation } from 'react-i18next';
import './OurPartners.css';
export default function OurPartners() {
  const {
    t
  } = useTranslation();
  return <section className="partners-container"><h2>{t('agency.resources')}</h2><p>{t('agency.resourceNote')}</p><ul>{[['React', 'https://react.dev/'], ['MDN', 'https://developer.mozilla.org/'], ['Node.js', 'https://nodejs.org/']].map(([name, url]) => <li key={name}><a href={url} target="_blank" rel="noopener noreferrer">{name}</a></li>)}</ul></section>;
}
